import { Box, Link, Badge } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import Color from '../base/Color'
import Typography from '../base/Typography'

export interface Notification {
  id: number
  link?: string
  label?: string
  date?: string
}

export type CardNotificationProps = {
  notification: Notification
  onRead(id: number): void
  isRead: boolean
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    notif: {
      padding: theme.spacing(2),
      width: 363
    },
    notifText: {
      color: theme.palette.common.black,
      textAlign: 'left'
    },
    notifBadge: {
      marginLeft: theme.spacing(1.5)
    },
    badgeColor: {
      background: theme.palette.error.main
    }
  })
)

const CardNotification: React.FC<CardNotificationProps> = (props) => {
  const classes = useStyles()
  const { notification, onRead, isRead } = props
  return (
    <Box
      className={classes.notif}
      bgcolor={isRead ? Color.primary[300] : 'white'}
    >
      <Badge
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        classes={{ badge: classes.badgeColor }}
        color="primary"
        variant="dot"
        invisible={isRead ? isRead : false}
      >
        <Link
          component="button"
          onClick={(): void => onRead(notification.id)}
          underline="none"
          variant="overline"
          classes={{ root: classes.notifText }}
          className={classes.notifBadge}
        >
          {notification ? notification.label : 'No Notifications'}
        </Link>
      </Badge>
      <Box display="flex" justifyContent="flex-end" marginTop={1}>
        <Typography
          color="primary"
          variant="caption"
          children={notification ? notification.date : 'mm dd, yyyy'}
        />
      </Box>
    </Box>
  )
}

export default CardNotification
